module.exports = __webpack_public_path__ + "img/1-2.47dc7676.png";